module.exports = __webpack_public_path__ + "static/EIIR-Header-1920x1080-6a09fbe0518283fca0c843d837976b0a.jpg";